module.exports = __webpack_public_path__ + "img/ex-person_sm.ace50fe4.png";